export const VIDEO_DETECTION_MODEL = {
	models: [
		{
			id: 'BFM',
			label: 'Biodrone Reindeer Model',
			description:
				'Best accuracy for reindeer: trained on herds like these, calves told apart',
			modelVersion: 'base_models/bfm/trained/reindeer-bfm-v8/reindeer-bfm-v8.pt',
		},
		{
			// backend: video_detection.GENERAL_SEARCH, SAM 3 text search in the frame loop (V12)
			id: 'SEARCH',
			label: 'General search',
			description:
				'Finds what you name; slower than the reindeer model, and the count is an estimate',
			modelVersion: null,
		},
	],
	defaultModelId: 'BFM',
};

// runs made before the general search keep a readable name
const LEGACY_LABELS = { 'BFM-SAM3-STREAM': 'Biodrone Reindeer Model', SAM3: 'General search' };

/** Pre-built select options for use in form components */
export const MODEL_OPTIONS = VIDEO_DETECTION_MODEL.models.map(model => ({
	value: model.id,
	label: model.label,
	description: model.description,
	modelVersion: model.modelVersion,
}));

/** Default select option (matches defaultModelId) */
export const DEFAULT_MODEL_OPTION =
	MODEL_OPTIONS.find(m => m.value === VIDEO_DETECTION_MODEL.defaultModelId) || MODEL_OPTIONS[0];

/** O(1) lookup map: model ID → human-readable label */
const MODEL_LABEL_MAP = {
	...LEGACY_LABELS,
	...Object.fromEntries(VIDEO_DETECTION_MODEL.models.map(m => [m.id, m.label])),
};

/**
 * Get the human-readable label for a model ID.
 * Falls back to the raw ID if not found in config.
 */
export const getModelLabel = modelId => MODEL_LABEL_MAP[modelId] || modelId;

/** What a job counts: the word, trimmed, or reindeer when there is no word. The wizard shows it and sends it. */
export const countSubject = word => (word || '').trim() || 'reindeer';

/** The model a subject is counted with: our reindeer model for reindeer, the general search for anything else. */
export const modelForSubject = subject => {
	const word = countSubject(subject).toLowerCase();
	const id = /^reindeers?$/.test(word) ? 'BFM' : 'SEARCH';
	return MODEL_OPTIONS.find(m => m.value === id) || DEFAULT_MODEL_OPTION;
};
